import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";
import {FRUtilities} from "#Formulas/FormulaCore/Utilities/FRUtilities";


export class FRForE extends FRBase{

    private Expression:FRBase;
    private Value:string='';
    private Key:string='';
    private Statement:FRBase;
    private ShouldBreak:boolean=false;

    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);
        this.Expression=FRFactory.GetFRElement(Options.E,this);
        this.Value=Options.V;
        this.Key=Options.K;
        this.Statement=FRFactory.GetFRElement(Options.D,this);
    }

    Parse(): any {

        return this.MaybeExecutePromise(this.Expression.Parse(),result=>{
            let keys=[];
            if(Array.isArray(result))
                keys=Array.from(result.keys())
            else
                for(let property in result)
                    keys.push(property);


            let lastResult=null;

            let iterator=(index=0)=>{
                if(index>=keys.length)
                    return lastResult;
                let key=keys[index];

                let value=result[key];
                this.Retriever.SetVar(this.Value,value);
                if(this.Key!='')
                    this.Retriever.SetVar(this.Key,key);

                return this.MaybeExecutePromise(this.Statement.Parse(),statementResult=>{
                    lastResult=statementResult;
                    if(this.ShouldBreak)
                        return lastResult;
                    else return iterator(index+1);
                })
            };

            return iterator(0);


        })






    }


    public ReturnWasExecuted(){
        this.ShouldBreak=true;
        FRUtilities.NotifyReturnToParent(this);
    }

    public BreakWasExecuted(){
        this.ShouldBreak=true;
    }


}

FRFactory.AddField('FE',FRForE);